import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { LoadingState } from '@/components/ui';
import { useAuth } from '@/hooks/useAuth';

import { paths } from './paths';

/**
 * Guards authenticated areas. The backend enforces the same rules -- this only
 * keeps the UI honest and avoids rendering screens that would 401/403.
 */
export function ProtectedRoute({ allowedRoles, fallback, children }) {
  const { status, isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (status === 'initialising') {
    return <>{fallback ?? <LoadingState label="Checking your session…" />}</>;
  }

  if (!isAuthenticated) {
    // Administrators have their own sign-in page; everyone else uses /login.
    const isAdminArea =
      location.pathname === paths.admin.root ||
      location.pathname.startsWith(`${paths.admin.root}/`);
    return (
      <Navigate
        to={isAdminArea ? paths.admin.login : paths.login}
        state={{ from: location }}
        replace
      />
    );
  }

  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    return <Navigate to={paths.home} replace />;
  }

  return <>{children ?? <Outlet />}</>;
}
